export default "__VITE_ASSET__0ae3a013__"